import { createContext, useCallback, useContext } from 'react'

export interface DocumentLeaveBypassContextValue {
  bypassOnce: () => void
  consumeBypass: () => boolean
}

export const DocumentLeaveBypassContext = createContext<DocumentLeaveBypassContextValue | null>(null)

export const useDocumentLeaveBypass = () => {
  const context = useContext(DocumentLeaveBypassContext)

  const bypassOnce = useCallback(() => {
    context?.bypassOnce()
  }, [context])

  return { bypassOnce }
}
